module.exports = __webpack_public_path__ + "img/goAi_titile.1398d08b.png";